import AbstractWidget from '../data/AbstractWidget.js';
import React from 'react';
import ReactDOM from 'react-dom';
import WidgetComponent from './WidgetComponent.jsx';
import PresetService from './PresetService.js';
import WidgetService from './WidgetService.js';
import Utility from '../core/Utility.js';

var formatDate = d3.time.format("%Y-%m-%d %H:%M:%S");

class Widget extends AbstractWidget {
	constructor(ctx, store, options, parentGuid, $q) { //isReadOnly = true, elDock, elTarget, cache, theme) {
		super(ctx, store);
		this.ctx.data.filters = [];
		this.$q = $q;
		options = Object.assign({
			'isReadOnly': true,
			'events': {
				'rendered': () => {},
				'infoClick': () => {},
				'failClick': () => {},
				'closeClick': () => { return true; },
				'titleChanged': () => {},
				'setValue': () => {},
				'filtered': () => {},
				'filterReset': () => {},
				'contextChanged': () => {},
				'setParamsReset': () => {}
			}
		}, options);
		this.isStarter = options.starter;
		this.parentGuid = parentGuid;
		this.isReadOnly = options.isReadOnly;
		this.widgetTheme = options.theme;
		this.elDock = options.elDock;
		this.elTarget = options.elTarget;

		this.currentWidgetType = Utility.exists('data.type', ctx) ? ctx.data.type : undefined; // chart type만 가지고있음.

		this._onFiltered = options.events.filtered;
		this._onFilterReset = options.events.filterReset;
		this._onRendered = options.events.rendered;
		this._onInfoClick = options.events.infoClick;
		this._onFailClick = options.events.failClick;
		this._onTitleChanged = options.events.titleChanged;
		this._onSetValue = options.events.setValue;
		this._onCloseClick = options.events.closeClick;
		this._onContextChanged = options.events.contextChanged;
		this._onSetParamsReset = options.events.setParamsReset;
		this.screenShotElement = undefined;

		this.registerLayout();

		if(!!options.cache) {
			this.endedAt = new Date();
			this.renderContainer(options.cache);
		}
		else {
			this.renderLoading([]);
		}

		if(!!this.model.datasource) {
			$(this.model.datasource).off(`filter.widget-${this.guid}`).on(`filter.widget-${this.guid}`, (e) => {
				if(Array.isArray(e.detail) && e.detail.length === 0 && !!this.rendered) {
					if(typeof this.rendered.clear === 'function') {
						this.rendered.clear();
					}
				}

			});
		}
	}

	registerLayout() {
		var el;
		if(!!this.elTarget) {
			el = this.elTarget;
		}
		else {
			el = this.elDock.find('.k-d-col[dock-id=' + this.ctx.guid + '] .contentbox')[0];
		}
		this.targetElement = el;
		// var btn = $('<button style="top:100px; z-index:5; position:absolute">').on('click', this.drilldown.bind(this));
		// $(this.targetElement).append(btn);
	}

	onDataRequested(resp) {
		super.onDataRequested(resp);
	}

	onDataArrived(e) {
		// this.startedAt = null;
		this.endedAt = new Date();
		this.latestData = e.detail.result || [];
		// console.log(resp);

		if(!!this.latestData) {
			// console.warn( Math.abs(this.endedAt - this.startedAt));
			this.ellapsed = Math.abs(this.endedAt - this.startedAt);
		}
		else {
			this.ellapsed = null;
		}

		this.renderContainer(this.latestData);
		super.onDataArrived(e);
	}

	onRefreshDataArrived(e) {
		this.endedAt = new Date();
		this.latestData = e.detail.result || [];

		if(!!this.latestData) {
			// console.warn( Math.abs(this.endedAt - this.startedAt));
			this.ellapsed = Math.abs(this.endedAt - this.startedAt);
		}
		else {
			this.ellapsed = null;
		}

		// this.renderContainer(this.latestData); // #2603 으로 인해 주석처리
		super.handleRefreshDataArrived(e);
	}

	onModelDestroyed() {
		this.renderBroken();
		super.onModelDestroyed();
	}

	onFailed(e) {
		var brokenMessage = e.detail;
		this.renderBroken(brokenMessage);
		super.onFailed();
	}

	onSnapshotClick(){
		this.takeSnapShot();
	}

	revealScreenShot(){
		this.screenShotElement.block.css("display", "block");
		$(this.targetElement).css("display", "none");
	}

	hideScreenShot(callback){
		this.screenShotElement.block.css("display", "none");
		$(this.targetElement).css("display", "block");
		this.screenShotElement.header.remove();
		this.screenShotElement.body.remove();
		this.screenShotElement.block.remove();
		this.screenShotElement = undefined;
		this.widgetElements = undefined;
		if(!!callback){
			callback();
		}
	}

	initScreenShotElements(){
		this.screenShotElement = {};
		this.screenShotElement.block = $('<div id="screen-shot" style="display: none;"></div>');
		this.screenShotElement.header = $('<img src="" id="clone-header"></img>');
		this.screenShotElement.body = $('<img src="" id="clone-body"></img>');
		$(this.screenShotElement.header).appendTo($(this.screenShotElement.block));
		$(this.screenShotElement.body).appendTo($(this.screenShotElement.block));		
		$(this.screenShotElement.block).insertAfter($(this.targetElement));
	}

	findWidgetElements(){
		this.widgetElements = {};
		this.widgetElements.contentsBox = this.elDock.find('.k-d-col[dock-id=' + this.guid + '] .contentbox');
		if(this.ctx.type === ' wordcloud'){
			this.widgetElements.container = this.elDock.find('.k-d-col[dock-id=' + this.guid + '] .widget-wordcloud');
		} else if(this.ctx.type === ' chart'){
			this.widgetElements.container = this.elDock.find('.k-d-col[dock-id=' + this.guid + '] .highcharts-container');
		}else {
			this.widgetElements.container = this.elDock.find('.k-d-col[dock-id=' + this.guid + '] .widget-container');
		}
		this.widgetElements.svg = this.widgetElements.container.find('svg');
	}

	takeSnapShot(snapShotAll , snapShotAllDeferred){
		var presetInfo = PresetService.getPresetInfo()
		this._suspend();
		if(this.screenShotElement === undefined){
			this.initScreenShotElements();
		}
		if(this.widgetElements === undefined){
			this.findWidgetElements();
		}
		var screenshotHeader = this.screenShotElement.header[0];
		var screenshotBody = this.screenShotElement.body[0];
		var contentsBox = this.widgetElements.contentsBox;
		var container = this.widgetElements.container;
		var svg = this.widgetElements.svg;
		var screenshotBlock = this.screenShotElement.block[0];

		if(!!svg && svg.length > 0){
			var bodyDeferred = this.$q.defer();
			var headerDeferred = this.$q.defer();
			var deferredQueue = [];
			deferredQueue.push(bodyDeferred.promise);
			deferredQueue.push(headerDeferred.promise);
			html2canvas(contentsBox[0],{
				onrendered: (contentsCanvas) => {
					this.$q.all(deferredQueue).then( () => {
						this.revealScreenShot();
						html2canvas(screenshotBlock,{
							onrendered: (contentsCanvasWithImg) => {
								var newCanvas = angular.copy(contentsCanvasWithImg);
								var newCanvasH = parseInt(newCanvas.getAttribute("height"));
								var newCanvasW = parseInt(newCanvas.getAttribute("width"));
								var ctx = newCanvas.getContext("2d");
								presetInfo.theme === 'white' ? ctx.fillStyle = "white":ctx.fillStyle = null;
								ctx.fillRect(0,0,newCanvasW,newCanvasH);
								ctx.fill();
								ctx.drawImage(contentsCanvasWithImg,0,0);
								var imgURI = newCanvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
								if(!!snapShotAll){
									snapShotAllDeferred.resolve();
									return;
								}
								this.triggerDownload(imgURI, 'png');
								this.hideScreenShot(() =>{
									this._resume();
								});
							}
						});
					});
					var widgetHeader = contentsBox.find('.widget-title');
					html2canvas(widgetHeader[0], {
						onrendered: (headerCanvas) => {
							var newCanvas = angular.copy(headerCanvas);
							var newCanvasH = parseInt(newCanvas.getAttribute("height"));
							var newCanvasW = parseInt(newCanvas.getAttribute("width"));
							var ctx = newCanvas.getContext("2d");
							presetInfo.theme === 'white' ? ctx.fillStyle = "white":ctx.fillStyle = null;
							ctx.fillRect(0,0,newCanvasW,newCanvasH);
							ctx.fill();

							var headerImg = screenshotHeader;
							ctx.drawImage(headerCanvas, 0, 0);

							var imgURI = newCanvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
							headerImg.src = imgURI;
							headerDeferred.resolve();
						}
					});
					
					html2canvas(container[0], {
						onrendered: (containerCanvas) => {
							var svgCanvas = angular.copy(containerCanvas);
							this.exportSvg2Img(svg[0], svgCanvas , svgCanvas.getContext("2d"), screenshotBody, bodyDeferred);
						}
					});
				}
			});
		} else {
			var deferred = this.$q.defer();
			html2canvas(contentsBox[0],{
				onrendered: (contentsCanvas) => {
					deferred.promise.then(() =>{
						var newCanvas = angular.copy(contentsCanvas);
						var newCanvasH = parseInt(newCanvas.getAttribute("height"));
						var newCanvasW = parseInt(newCanvas.getAttribute("width"));
						var imgURI = undefined;
						var ctx = undefined;
						var threeDCanvas = undefined;
						ctx = newCanvas.getContext("2d");
						presetInfo.theme === 'white' ? ctx.fillStyle = "white":ctx.fillStyle = null;
						ctx.fillRect(0,0,newCanvasW,newCanvasH);
						ctx.fill();
						if(!!this.isStreamQueryWidget || (this.ctx.type === 'networkgraph3d')|| (this.ctx.type === 'globe3d')||(this.ctx.type === 'topology3d')){
							// 서비스에서 canvas 혹은 png 가져오기.
							if (!!this.rendered && !!this.rendered.takePicture) {
								imgURI = this.rendered.takePicture();//.replace("image/png", "image/octet-stream");
							}
							// ctx.drawImage(threeDCanvas,0,0);
							// imgURI = newCanvas.toDataURL();
						} else {
							ctx.drawImage(contentsCanvas,0,0);
							imgURI = newCanvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
						}
						
						if(!!snapShotAll){
							snapShotAllDeferred.resolve();
							return;
						}
						this.triggerDownload(imgURI, 'png');
					});

					html2canvas(container[0], {
						onrendered: (containerCanvas) => {
							deferred.resolve();
						}
					});
				}
			});
		}
	}

	exportSvg2Img(svg, canvas , ctx , target, deferred){
		//console.log("svg = ", svg);
		var data = (new XMLSerializer()).serializeToString(svg);
		var DOMURL = window.URL || window.webkitURL || window;
		var img = new Image();
	 	var svgBlob = new Blob([data], {type: 'image/svg+xml;charset=utf-8'});
		var url = DOMURL.createObjectURL(svgBlob);

		img.onload = function () {
			ctx.drawImage(img, 0, 0);
		
		   	var imgURI = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
		   	target.src = imgURI;
		   	DOMURL.revokeObjectURL(imgURI);
		    deferred.resolve();
		};

		img.src = url;
	}

	triggerDownload (imgURI, nameExtension) {
		var a = document.createElement('a');
		a.setAttribute('download', this.ctx.name+ '_'+this.ctx.type+'.'+nameExtension);
		a.setAttribute('href', imgURI);
		a.setAttribute('target', '_blank');
		a.click();
	}

	renderLoading(result) {
		if(!!this.targetElement) {
			ReactDOM.render(
				<WidgetComponent
					title={this.ctx.name}
					isLoading={true}
					isCustomQuery={!!this.isCustomQueryWidget}
					isStreamQuery={!!this.isStreamQueryWidget}
					isPersistent={!!this.isPersistentWidget}
					isStarter={!!this.isStarter}
					isReadOnly={this.isReadOnly}
					onPauseClick={(!!this.isCustomQueryWidget) ? null : this.onPauseClick.bind(this)}
					onRefreshClick={(!!this.isCustomQueryWidget) ? null :this.onRefreshClick.bind(this)}
					onInfoClick={this._onInfoClick.bind(this, this)}
					onCloseClick={this.onCloseClickDefault.bind(this)}
					onTitleChanged={this.onTitleChangedDefault.bind(this)}
					onSnapshotClick={this.onSnapshotClick.bind(this)}
					ellapsed={this.ellapsed}>
				</WidgetComponent>,
				this.targetElement);

			// this._render(result, true); // #2603 으로 인해 주석처리

			// 캐시된 데이터를 뿌려주자
			// 그냥 Interval에 걸릴때는 필요없고 (똑같은 데이터를 렌더링할테니) resume 할때만 불러주자

			// if(this._isSuspended) {
			// 	// console.log('render cache', this.ctx.name)
			// 	this._render(cache);
			// 	this._isSuspended = false;
			// }
		}
	}

	renderContainer(result, ignoreNodata) {
		this.renderWidgetComponent(result, ignoreNodata);
	}

	renderWidgetComponent(result, ignoreNodata = false) {
		if(!!this.targetElement) {
			ReactDOM.render(
				<WidgetComponent
					title={this.ctx.name}
					isLoading={false}
					isCustomQuery={!!this.isCustomQueryWidget}
					isStreamQuery={!!this.isStreamQueryWidget}
					isPersistent={!!this.isPersistentWidget}
					isStarter={!!this.isStarter}
					isReadOnly={this.isReadOnly}
					noData={(!result.length && !this.isCustomQueryWidget && !this.isStreamQueryWidget && !ignoreNodata) ? true : false}
					onPauseClick={(!!this.isCustomQueryWidget) ? null : this.onPauseClick.bind(this)}
					onRefreshClick={(!!this.isCustomQueryWidget) ? null :this.onRefreshClick.bind(this)}
					onInfoClick={this._onInfoClick.bind(this, this)}
					onCloseClick={this.onCloseClickDefault.bind(this)}
					onTitleChanged={this.onTitleChangedDefault.bind(this)}
					onSnapshotClick={this.onSnapshotClick.bind(this)}
					updatedAt={formatDate(this.endedAt)}
					interval={this.interval}>
				</WidgetComponent>,
				this.targetElement);

			this._render(result);
		}
	}

	customWidgetResume(){
		this.resume();
	}

	renderBroken(brokenMessage) {
		if(!!this.targetElement) {
			var hasLatestData = (Array.isArray(this.latestData) && this.latestData.length);
			ReactDOM.render(
				<WidgetComponent
					title={this.ctx.name}
					isLoading={false}
					isCustomQuery={!!this.isCustomQueryWidget}
					isStreamQuery={!!this.isStreamQueryWidget}
					isPersistent={!!this.isPersistentWidget}
					isStarter={!!this.isStarter}
					isReadOnly={this.isReadOnly}
					isDataSourceBroken={true}
					brokenMessage={brokenMessage}
					hasLatestData={hasLatestData}
					onPauseClick={null}
					onRefreshClick={(!!this.isCustomQueryWidget) ? null :this.onRefreshClick.bind(this)}
					onInfoClick={this._onInfoClick.bind(this, this)}
					onCloseClick={this.onCloseClickDefault.bind(this)}
					onFailClick={this._onFailClick.bind(this, brokenMessage)}
					onSnapshotClick={this.onSnapshotClick.bind(this)}
					onTitleChanged={this.onTitleChangedDefault.bind(this)}>
				</WidgetComponent>,
				this.targetElement);
		}
	}

	_render(result) {
		var doNotCheckResult = false;
		if(this.isCustomQueryWidget){
			doNotCheckResult = true;
		} else if(this.isStreamQueryWidget){ // variable of abstract class
			doNotCheckResult = true;
		} else if(this.isPersistentWidget){
			doNotCheckResult = true;
		}

		var presetInfo = PresetService.getPresetInfo(),
			presetTheme = presetInfo ? presetInfo.theme : 'white';

		if(result.length > 0 || doNotCheckResult) {
			var actualElement = $(this.targetElement).find('.widget-container');
			
			if(!this.service){
				this.service = WidgetService.get(this.ctx.type);
			}

			if(!this.rendered) {
				Object.assign(this.ctx.data, {
					'$$interval': this.interval
				});
				try{
					this.rendered = this.service.render(actualElement, result, this.ctx.data, Object.assign({theme: this.widgetTheme || presetTheme}, {columnInfo: this.columns}));
				} catch(e){
					console.warn("render error, type of this widget =" , this.ctx.type);
					console.warn("render error, WidgetService =" , WidgetService);
				}
				if(!this.rendered){
					return;
				}
				this.addDrilldownEvent();
				if(typeof this.rendered.dispatchEvent === 'function') {
					var e = new Event('show');
					this.rendered.dispatchEvent(e);
				}
			}
			else { // 이부분은 interval이 되었거나, property를 업데이트 할때 타는부분 
				if( !!this.isCustomQueryWidget ){ // 사용자 정의 위젯에서 apply 할때도 이부분을 탄다.
					this.rendered.update(actualElement, result, this.ctx.data);
				} else if((this.currentWidgetType === this.ctx.data.type)) { // chart 때문에 chart 밑에 line, pie등의 수정때문
					this.rendered.update(result, this.ctx, {columnInfo: this.columns});
				} else {
					Object.assign(this.ctx.data, {
						'$$interval': this.interval
					});

					this.rendered = this.service.render(actualElement, result, this.ctx.data, Object.assign({theme: this.widgetTheme || presetTheme}, {columnInfo: this.columns}));
					this.addDrilldownEvent();
					this.rendered.update(result, this.ctx, {columnInfo: this.columns});
				}

				this.currentWidgetType = this.ctx.data.type;
			}
		}else {
			if(!!this.rendered) {
				if(typeof this.rendered.dispatchEvent === 'function') {
					var e = new Event('destroy');
					this.rendered.dispatchEvent(e);
				} else if(!!this.rendered.destroy){
					this.rendered.destroy();
				}
				this.rendered = null;
			}
		}
	}

	updateContext(context) {
		super.updateContext(context);
		//this.renderLoading(this.latestData);
		//this.model.clearAfterQueryString();
		if(!!this.rendered) {
			this.removeDrilldownEvent();
			if(typeof this.rendered.dispatchEvent === 'function') {
				var e = new Event('destroy');
				this.rendered.dispatchEvent(e);
			}
			this.rendered = null;
			this.ellapsed = null;
			this.latestData = null;
			this.renderContainer(this.latestData || [], true);
			if(!this.isActive){
				this._suspend();
			}
		}
	}

	suspend() {
		this._isSuspended = true;
		super.suspend();
		if(!!this.targetElement) {
			if(ReactDOM.unmountComponentAtNode(this.targetElement)){
				$(this.targetElement).empty();
			}
		}
		this.targetElement = null;

		if(!!this.rendered) {
			this.removeDrilldownEvent();
			if(typeof this.rendered.dispatchEvent === 'function') {
				var e = new Event('hide');
				this.rendered.dispatchEvent(e);
			} else if(!!this.rendered.destroy){
				this.rendered.destroy();
			}
			this.rendered = null;
			// this.ellapsed = null;
		}
	}

	resume() {
		this.registerLayout();
		if(Array.isArray(this.latestData)) {
			this.renderContainer(this.latestData);
		}
		this.model.clearAfterQueryString();
		super._resume();
	}


	onPauseClick(val) {
		if(!val) {
			super.suspend();
		}
		else {
			super._resume();
		}
	}

	refreshCallback(){
		if(!this.latestData.length && this.ctx.type === 'grid') {
			if(Utility.exists('ctx.data.filters', this)) {
				this.ctx.data.filters = [];
			}
		}
		this.renderContainer(this.latestData);

		if(!!this.rendered && typeof this.rendered.clear === 'function') {
			this.rendered.clear();
		}
	}

	onRefreshClick() {
		super.refreshStart();
		if(this.rendered && typeof this.rendered.zoomOut === 'function') {
			this.rendered.zoomOut();
		}
	}

	onRefreshClickOld() {
		this.model.clearAfterQueryString();

		if(!this.latestData.length && this.ctx.type === 'grid') {
			if(Utility.exists('ctx.data.filters', this)) {
				this.ctx.data.filters = [];
			}
		}

		this.renderLoading(this.latestData);

		if(!!this.rendered && typeof this.rendered.clear === 'function') {
			this.rendered.clear();
		}
		super.refreshOld();
	}

	onCloseClickDefault() {
		if(this._onCloseClick(this)) {
			var elBox = this.elDock.find('.k-d-col[dock-id=' + this.ctx.guid + ']')[0];
			elBox.obj.close();
			this.suspend();
			this.removeDrilldownEvent();
		}
	}

	onTitleChangedDefault(newval) {
		this.ctx.name = newval;
		this._onTitleChanged.call(this, newval);
	}

	onFiltered(fn) {
		this._onFiltered = fn;
		return this;
	}

	onFilterReset(fn) {
		this._onFilterReset = fn;
		return this;
	}

	// onSetValue(fn) {
	// 	this._onSetValue = fn;
	// 	return this;
	// }

	onRendered(fn) {
		this._onRendered = fn;
		return this;
	}

	onInfoClick(fn) {
		this._onInfoClick = fn;
		return this;
	}

	onCloseClick(fn) {
		this._onCloseClick = fn;
		return this;
	}

	onTitleChanged(fn) {
		this._onTitleChanged = fn;
		return this;
	}

	removeDrilldownEvent(){
		$(this.rendered).off('contextChanged');
		$(this.rendered).off('set');
		$(this.rendered).off('filter');
		$(this.rendered).off('filterReset');
		this.model.removeDatasourceEvent();
	}

	addDrilldownEvent() {

		$(this.rendered).off('contextChanged').on('contextChanged', e => {
			var ret = e.detail;
			this.ctx.data[ret.prop] = ret.context;
			// console.log( e.detail.prop, e.detail.context , this.ctx.data);

			this._onContextChanged.call(this);
		});

		$(this.rendered).off('set').on('set', e => {
			e.originalEvent.customWidgetGuid = this.guid;
			this._onSetValue(this, e.originalEvent);
		});

		$(this.rendered).off('filter').on('filter', e => {
			var model = this.model;
			if(!!e.originalEvent.detail && !!e.originalEvent.detail.after) {
				model.setAfterQueryString(e.originalEvent.detail.query);
				if(!!this.isActive){
					this._restart();
				} else {
					this.refreshStart();
				}
				
			}
			else {
				this._onFiltered.call(this, this, model.datasource, e.originalEvent.detail.query);
			}

		});

		$(this.rendered).off('filterReset').on('filterReset', e => {
			var model = this.model;
			if(!!e.originalEvent.detail && !!e.originalEvent.detail.after) {
				model.clearAfterQueryString();
				if(!!this.isActive){
					this._restart();
				} else {
					this.refreshStart();
				}
			}
			else {
				this._onFilterReset.call(this, this, model.datasource);
			}

		});

		$(this.rendered).off('setParamsReset').on('setParamsReset', e => {
			this._onSetParamsReset(this.guid);
		});

		this.model.setDatasourceEvent(this.datasourceChangeHandler.bind(this));
	}

	destroy() {
		this.suspend();

		if(!!this.rendered) {
			if(typeof this.rendered.dispatchEvent === 'function') {
				var e = new Event('destroy');
				this.rendered.dispatchEvent(e);
			} else if(!!this.rendered.destroy){
				this.rendered.destroy();
			}
			this.rendered = null;
			this.service = null;
			this.ellapsed = null;
			this.service = WidgetService.get(this.ctx.type);
		}
	}

	_runTimer() { // enter point when change preset.
		super._runTimer();
	}

	_stopTimer() {
		super._stopTimer();
	}
}

export default Widget;



// WEBPACK FOOTER //
// ./resources/WEB-INF/src/dashboard/Widget.jsx